var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { api } from 'helpers/Api';
import Device from './Model';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.data = [];
        this.loaded = false;
        this.set = function (values) {
            // console.log('Devices-Store - set - values: ', values)
            _this.data = values.map(function (value) { return new Device(value); });
            _this.loaded = true;
            return _this.data;
        };
    }
    default_1.prototype.read = function (id) {
        var _this = this;
        if (id)
            return api.get('devices' + id);
        return api.get('devices').then(function (value) {
            return _this.set(value);
        });
    };
    default_1.prototype.readEcommerce = function () {
        return api.get('devices').then(function (devices) { return devices.filter(function (device) { return device.serial === 'DEMO000033'; }); });
    };
    default_1.prototype.readAppDevices = function () {
        return api.get('devices').then(function (devices) { return devices.filter(function (device) {
            return device.serial !== 'DEMO000033' && device.model.toLowerCase() !== 'emulator' && !device.serial.includes('EMULATOR');
        }); });
    };
    __decorate([
        observable
    ], default_1.prototype, "data", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loaded", void 0);
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Devices/Store.ts
// module id = 707
// module chunks = 0